module.exports = __webpack_public_path__ + "img/AQI-la_against_air_pollution.f6340331.png";